import Vue from 'vue';

export const eventBus = new Vue();



// WEBPACK FOOTER //
// ./resources/assets/js/eventBus.js